module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/team-cb6d4ecf.svg";